module.exports = __webpack_public_path__ + "static/assets/8ef75ee8511008396e9b701840e87882.gif";